import { Injectable } from '@angular/core';
import {Headers,Http} from "@angular/http";
import {environment} from "../../../environments/environment";
import { NgModel } from '@angular/forms';

@Injectable()
export class UsermasterService {
      private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
      constructor(
        private http: Http
      ) { }

      //Fetch All Userlist registered
      getUserList(offset,searchText) {
        let body = "offset="+offset+"&searchText="+searchText+""
        const promise = new Promise((resolve, reject) => {
        const apiURL = environment.BASE_URL+'/userslist';
            this.http.post(apiURL,body,{headers: this.headers})
            .toPromise()
            .then(
              res => { // Success
                resolve(res.json());
              }
            ).catch(
            err => {
              console.log(err.json());
              reject(err.json());
            }
          );
        });
        return promise;
      }

    //Fetch single user information
    getUserInfo(iUserId){
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL+'/userinfo/'+iUserId;
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    //Delete User
    deleteUserCall(iUserId){
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL+'/deleteuser/'+iUserId;
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    //Delete User
    resetpasswordCall(authcode,password,confirmpassword){
        let body = "authcode="+authcode+"&password="+password+"&confirmpassword="+confirmpassword+""
        const promise = new Promise((resolve, reject) => {
        const apiURL = environment.BASE_URL+'/resetpassword';
            this.http.post(apiURL,body,{headers: this.headers})
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/usermaster/services/usermaster.service.ts